export type PercentageStatus = 'error' | 'warning' | 'success'

export const getPercentageStatus = (value: number): PercentageStatus => {
  if (value < 70) return 'error'
  if (value < 86) return 'warning'
  return 'success'
}

export const getPercentageColor = (value: number) => {
  const colors: Record<PercentageStatus, string> = {
    error: '#ef4444',
    warning: '#f59e0b',
    success: '#22c55e',
  }

  return colors[getPercentageStatus(value)]
}
